var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Fragment, Component } from "react";
import { pipe } from "ramda";
import OldFooter from "./OldFooter";
import { copywriter, underwriter, address, generateColumns } from "./config.js";
import { wrapDomain, wrapAncor, appendQuery } from "../../../utils";
import { withTheme } from "styled-components";
import { Footer as Astro3Footer, Theme as Astro3Theme, FooterLogos } from '@simply-fin-services/astronomix3';
import OM_Footer from "../../Partners/OM/Footer";
import ABSA_Footer from "../../Partners/ABSA/Footer";
import RML_Footer from "../../Partners/RML/Footer";

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      isDark: false,
      darkmode: 'light'
    };
    _this.toggleTheme = _this.toggleTheme.bind(_this);
    return _this;
  }

  Footer.prototype.toggleTheme = function toggleTheme() {
    this.setState({
      isDark: !this.state.isDark,
      darkmode: this.state.isDark === true ? 'light' : 'dark'
    });
  };

  Footer.prototype.render = function render() {
    var _props = this.props,
        columns = _props.columns,
        showOmart = _props.showOmart,
        showLogos = _props.showLogos,
        theme = _props.theme,
        websiteDomain = _props.websiteDomain;
    var mustShowLogos = showOmart || showLogos;
    var conf = {
      copywriter: copywriter(theme),
      underwriter: underwriter(theme),
      address: address(theme),
      columns: columns
    };

    if (theme.name === 'oldmutual') {
      return React.createElement(OM_Footer, null);
    } else if (theme.name === "absa") {
      return React.createElement(ABSA_Footer, null);
    } else if (theme.name === "rml") {
      return React.createElement(RML_Footer, this.props);
    } else if (theme.name === "simply") {
      var themeStyle = this.state.isDark ? "simplydark" : "simplylight";
      return React.createElement(Astro3Theme, {
        themeName: themeStyle,
        smallMargin: true
      }, showLogos && React.createElement(FooterLogos, null), React.createElement(Astro3Footer, {
        websiteDomain: websiteDomain,
        darkmode: this.state.darkmode,
        toggleTheme: this.toggleTheme,
        alwaysLight: true
      }), ' ');
    } else {
      return React.createElement(Fragment, null, React.createElement(OldFooter, _extends({}, conf, {
        showOmart: mustShowLogos
      })));
    }
  };

  return Footer;
}(Component);

var DefaultFooterComponent = function (_Component2) {
  _inherits(DefaultFooterComponent, _Component2);

  function DefaultFooterComponent() {
    _classCallCheck(this, DefaultFooterComponent);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  DefaultFooterComponent.prototype.render = function render() {
    var _props2 = this.props,
        domain = _props2.domain,
        showOmart = _props2.showOmart,
        showLogos = _props2.showLogos,
        theme = _props2.theme,
        queryString = _props2.queryString,
        websiteDomain = _props2.websiteDomain;
    var linkF = pipe(wrapDomain(domain), appendQuery(queryString), wrapAncor);
    var cols = generateColumns(linkF);
    return React.createElement(Fragment, null, React.createElement(Footer, {
      columns: cols,
      showOmart: showOmart,
      showLogos: showLogos,
      theme: theme,
      websiteDomain: websiteDomain
    }));
  };

  return DefaultFooterComponent;
}(Component);

export default withTheme(Footer);
export var DefaultFooter = withTheme(DefaultFooterComponent);